const defaultState = {};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'INCOMING_FAXES_SUCCESS':
            return action.incomingFaxes || defaultState;
        case 'INCOMING_FAXES_ERROR':
            return [];
        case 'CHECK_PENDING_FAXES_SUCCESS':
            return { ...state, isPendingFax: action.data };
        default:
            return state;
    }
}
